module.exports = __webpack_public_path__ + "cd-arrow.f81f938ac97ef25d1d59.svg";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/assets/images/cd-arrow.svg
// module id = ../../../../../src/assets/images/cd-arrow.svg
// module chunks = main